import { apiRequest } from './client'
import type { AuditLogListResponse, AuditResult } from '@/types'

export interface AuditLogQuery {
  actor_user_id?: string
  action?: string
  target_type?: string
  target_id?: string
  result?: AuditResult
  created_from?: string
  created_to?: string
  limit?: number
  offset?: number
}

export async function listAuditLogs(params: AuditLogQuery = {}): Promise<AuditLogListResponse> {
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === '') continue
    query.set(key, String(value))
  }
  const qs = query.toString()
  return apiRequest<AuditLogListResponse>(`/api/admin/audit-logs${qs ? `?${qs}` : ''}`)
}
